export default __webpack_public_path__ + "static/media/trident-5.4c58aaee.jpg";